import type { ModalShowProps } from 'antd-mobile/es/components/modal';
import { Modal, Image } from 'antd-mobile';
import { getCDNAssets } from '@/utils';

import styles from './show.module.less';

export type ShowCouponModalOptions = ModalShowProps & {
  grayBg?: boolean;
};

const showCouponModal = (options: ShowCouponModalOptions) => {
  const { bodyStyle, grayBg, ...rest } = options;

  return Modal.show({
    header: (
      <Image className={styles.modalHeadImg} placeholder={null} src={getCDNAssets('product_coupon_dialog_icon.png')} />
    ),
    bodyStyle: { background: grayBg ? '#f2f2f2' : undefined, ...bodyStyle },
    closeOnMaskClick: true,
    showCloseButton: true,
    ...rest,
  });
};

export default showCouponModal;
